// Imports
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tippy from '@tippyjs/react';
import { darken } from 'polished';
import React from 'react';
import styled from 'styled-components/macro';
import LinkButton from '../../../../../../shareables/foundation/front-end/components/buttons/link';
import DateTimeCell from '../../../../../../shareables/foundation/front-end/components/tables/date-time-cell';
import tippyProps from '../../../../../../shareables/foundation/front-end/utils/tippy-props';
import { GetPaymentsResponse } from '../../../../../../shareables/types/api/main/website/payments/get';
import formatCurrency from '../../../../../../shareables/utils/project-specific/formatting/format-currency';
import { GeneratedThemeProps } from '../../../../../templates/template-style';


// Styled components
const ReceiptButton = styled(LinkButton)<{ theme: GeneratedThemeProps }>`
	background-color: ${(props) => props.theme.baseColor};
	
	&:hover,
	&:focus {
		background-color: ${(props) => darken(0.05, props.theme.baseColor)} !important;
	}
`;


// Define the accepted props
interface Props {
	payment: GetPaymentsResponse[0];
}


// Function component
const PaymentHistoryRow: React.FC<Props> = ({ payment }) => {
	// Build emphasized
	let status: React.ReactElement | string;
	
	switch (payment.status) {
		case 'PROCESSING':
			status = (
				<React.Fragment>
					Processing <br /> <small className='is-gray'>Takes 3-5 business days</small>
				</React.Fragment>
			);
			
			break;
		case 'DISPUTED':
			status = 'Disputed & refunded';
			break;
		case 'REFUNDED':
			status = 'Refunded';
			break;
		case 'FAILED':
			status = 'Unsuccessful';
			break;
		default:
			status = '';
	}
	
	
	// Return JSX
	return (
		<tr>
			{payment.status === 'SUCCEEDED' ? (
				<DateTimeCell dateTime={new Date(payment.received ?? '').toISOString() ?? ''} />
			) : (
				<td>
					<em>{status}</em>
				</td>
			)}
			<td>{payment.member ?? <em>No longer exists</em>}</td>
			<td>{payment.paymentOption}</td>
			<td style={{ textAlign: 'center' }}>{formatCurrency(payment.amount)}</td>
			<td style={{ textAlign: 'center' }}>
				{payment.status === 'SUCCEEDED' ? (
					<Tippy {...tippyProps} content='View this receipt'>
						<ReceiptButton to={`/payments/receipt/${payment.id}`} aria-label='View receipt' smaller>
							<FontAwesomeIcon icon={faSearch} />
						</ReceiptButton>
					</Tippy>
				) : (
					'N/A'
				)}
			</td>
		</tr>
	);
};

export default PaymentHistoryRow;
